/**
 * @description Email Preferences controller endpoints settings
 * @module API controller / EmailPreferences
 */

module.exports = {
  getEmailPreferences: {
    /**
     * @description Returns all 5 email preference categories and their opted_in state for the current user.
     * @param  {object} options
     * @param  {number} options.accountId
     * @returns {object} - Request settings.
     */
    settings: ({ accountId }) => ({
      endpoint: `/account/${accountId}/users/email_preferences`,
      method: 'GET',
    }),
  },

  updateEmailPreference: {
    /**
     * @description Updates the opted_in value for a single email preference category.
     * @param  {object} options
     * @param  {number} options.accountId
     * @param  {string} options.category  - One of: using_simpli5, transactional, marketing
     * @param  {boolean} options.optedIn
     * @returns {object} - Request settings.
     */
    settings: ({ accountId, category, optedIn }) => ({
      endpoint: `/account/${accountId}/users/email_preferences`,
      body: { category, opted_in: optedIn },
      method: 'PUT',
    }),
  },

  unsubscribeAll: {
    /**
     * @description Opts the current user out of all non-transactional email categories.
     * @param  {object} options
     * @param  {number} options.accountId
     * @returns {object} - Request settings.
     */
    settings: ({ accountId }) => ({
      endpoint: `/account/${accountId}/users/email_preferences/unsubscribe_all`,
      method: 'POST',
    }),
  },
}
